<template>
  <div id="app">
    <router-view></router-view>
    <TheModals />
  </div>
</template>

<script>
import '@/utils/chartsScaleExtension'
import { statisticalStore } from '@/mixins/statisticalMixin'
import { userManagerStore } from '@/mixins/userManagerMixin'
import { authStore } from './mixins/authStoreMixin'
import { auctionManagerStore } from './mixins/auctionsManagerMixin'
import { carManagerStore } from './mixins/carManagerMixin'
import { salesRevenueManagerStore } from './mixins/salesRevenueManagerMixin'
import { managersManagerStore } from './mixins/managersManagerMixin'
import { users } from '@/utils/dictionaries/users.fake'
import api from '@/api/api'

export default {
  name: 'App',

  created () {
    this.$socket && this.$socket.init()
    this.$store.dispatch(`${statisticalStore.moduleName}/${statisticalStore.actionTypes.ACTION_INIT_WS}`)
    this.$store.dispatch(`${userManagerStore.moduleName}/${userManagerStore.actionTypes.ACTION_INIT_WS}`)
    this.$store.dispatch(`${authStore.moduleName}/${authStore.actionTypes.ACTION_INIT_WS}`)
    this.$store.dispatch(`${auctionManagerStore.moduleName}/${auctionManagerStore.actionTypes.ACTION_INIT_WS}`)
    this.$store.dispatch(`${carManagerStore.moduleName}/${carManagerStore.actionTypes.ACTION_INIT_WS}`)
    this.$store.dispatch(`${salesRevenueManagerStore.moduleName}/${salesRevenueManagerStore.actionTypes.ACTION_INIT_WS}`)
    this.$store.dispatch(`${managersManagerStore.moduleName}/${managersManagerStore.actionTypes.ACTION_INIT_WS}`)
    this.$store.dispatch(`${statisticalStore.moduleName}/${statisticalStore.actionTypes.ACTION_LOAD_APP_ROUTES}`)

    const vm = this

    api.interceptors.response.use(undefined, (err) => {
      return new Promise((resolve, reject) => {
        if (err.response && err.response.status === 401) {
          vm.$store.dispatch(`${authStore.moduleName}/${authStore.actionTypes.ACTION_SIGN_OUT}`)
          vm.$router.push('/login')
        }
        throw err
      })
    })

    if (process.env.NODE_ENV === 'development') {
      window.userFakers = () => {
        const promises = []
        users.forEach(user => {
          const asyncFn = async (user) => {
            try {
              const createdUser = await this.$store.dispatch(`${authStore.moduleName}/${authStore.actionTypes.ACTION_ADD_USER}`, { user })
              await this.$store.dispatch(`${authStore.moduleName}/${authStore.actionTypes.ACTION_UPLOAD_USER_PHOTO}`, { formData: user.photo, toUserId: createdUser.data?.user?.id })
              console.log('%c%s', 'color: var(--info);', 'User created: ' + createdUser.data?.user?.id)
            } catch (error) {
              console.log('%c%s', 'color: var(--danger);', 'User creating failed: ', user.username)
              console.log(error)
            }
          }

          promises.push(asyncFn(user))
        })

        Promise.all(promises)
      }
    }
  }
}
</script>
<style lang="scss">
  // Import Main styles for this application
  @import 'assets/styles/main.scss';
</style>
